import React from 'react';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import * as ReactSurvey from 'survey-react';
import 'survey-react/survey.css';
import 'survey-react/modern.css';
import './Survey.less';
import fetch from 'node-fetch';

class Survey extends React.Component {
	questions = null;

	constructor(props) {
		super(props);
		this.state = {
			questions: null
		};
	}

	componentDidMount() {
		ReactSurvey.StylesManager.applyTheme('modern');
		i18next.on('languageChanged', this.languageChanged);
		this.getQuestions();
	}

	languageChanged = () => {
		this.getQuestions();
	};

	getQuestions = () => {
		if (this.questions) {
			this.bindSurvey();
			return;
		}
		fetch('/api/getQuestions').then((response) => response.json()).then((results) => {
			if (results && results.value && results.value.length > 0) {
				this.questions = results.value;
				this.bindSurvey();
			}
		});
	};

	bindSurvey = () => {
		const { t, i18n: { language }, projectInfo } = this.props;
		const questions = this.questions.map((question, index) => {
			const { fields: { Title, TitleEn, TitleAr, TitleFr, QuestionType, QuestionEn, QuestionFr, QuestionAr } } = question;
			return {
				type: 'panel',
				name: `panel${index}`,
				title: language === 'en' ? TitleEn : language === 'fr' ? TitleFr : TitleAr,
				elements: [
					{
						type: QuestionType.toLowerCase(),
						name: Title,
						title: language === 'en' ? QuestionEn : language === 'fr' ? QuestionFr : QuestionAr,
						isRequired: QuestionType.toLowerCase() !== 'comment',
						mininumRateDescription: t('survey_notSatisfied'),
						maximumRateDescription: t('survey_satisfied')
					}
				]
			};
		});
		questions.push({
			type: 'panel',
			name: `panelFilledBy`,
			title: t('survey_filledBy'),
			elements: [
				{
					name: 'FilledBy',
					type: 'text',
					title: t('survey_filledBy'),
					isRequired: true,
					defaultValue: projectInfo.projectInfo.ClientContactName
				},
				{
					name: 'ContactEmail',
					type: 'text',
					inputType: 'email',
					title: t('survey_email'),
					isRequired: true,
					defaultValue: projectInfo.projectInfo.Clientemail,
					validators: [
						{
							type: 'email'
						}
					]
				}
			]
		});
		this.setState({ questions: { elements: questions } });
	};

	onComplete = async (survey, options) => {
		const saveResult = await this.saveSurvey(survey.data);
		if (saveResult.ok) {
			// Swal.fire({
			// 	title: 'Saved!',
			// 	icon: 'success',
			// });
		} else {
			options.showDataSavingError();
		}
	};

	saveSurvey = async (survey) => {
		const { surveyInfo, surveyToken, projectInfo, i18n: { language } } = this.props;
		const saveResponse = await fetch('/api/saveSurvey', {
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				survey,
				id: surveyInfo.id,
				surveyToken: surveyToken,
				language,
				accountManagerEmail:
					projectInfo.accountManagerEmail && projectInfo.accountManagerEmail[0]
						? projectInfo.accountManagerEmail[0]
						: null
			}),
			method: 'POST'
		});
		return saveResponse;
	};

	render() {
		let model;
		const { i18n: { language }, surveyInfo, t } = this.props;
		const { questions } = this.state;
		if (questions && surveyInfo) {
			model = new ReactSurvey.Model(questions);
			if (surveyInfo.IsFilled) {
				model.data = surveyInfo;
				model.mode = 'display';
			}
		}
		return (
			<React.Fragment>
				{surveyInfo.IsFilled && <div className="survey__filled">{t('survey_alreadyFilled')}</div>}
				<div className="survey">
					{model && (
						<ReactSurvey.Survey
							model={model}
							onComplete={this.onComplete}
							showQuestionNumbers="false"
							locale={language}
						/>
					)}
				</div>
			</React.Fragment>
		);
	}
}

export default withTranslation('translations')(Survey);
